import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Button from 'components/common/Button/Button'
import Link from 'components/common/Link/Link'
import Media from 'components/common/Media'
import Popover from 'components/common/Popover'
import ToggleBtn from 'components/common/Filters/FilterGroup/components/FilterGroupToggle'
import { DefaultPopoverInnerContent } from 'components/common/Popover/elements'
import { filterProps } from 'helpers/utils'

const PopoverLink = styled.span`
  font: inherit;
  display: block;
  margin: -16px -35px -12px -20px;
  padding: 16px 35px 12px 20px;
  ${Mixin.ellipsis()}
`

const PopoverInnerContent = styled(DefaultPopoverInnerContent)`
  font: inherit;
  width: auto;
`

const PopoverWrapper = styled.span`
  position: absolute;
  bottom: -25px;
`

const SizeDetails = ({
  tireSizes = [],
  diameter,
  exceedsLimit,
  expanded,
  toggleHandlers
}) =>
  <Sizes>
    <Diameter>{ diameter }”<Media.ScreenReader>inch</Media.ScreenReader> Wheel Diameter</Diameter>
    <SizeList>
      {
        tireSizes.map(({ displayName, tireDetailUrl }) =>
          <Size key={ tireDetailUrl }>
            <Follow data-at-line-tiresku follow_alternative to={ tireDetailUrl }>
              {
                displayName.length > 20 ?
                  <StyledPopover
                    showOnHover
                    title={ displayName }
                    info={ displayName }
                    components={{ PopoverLink, PopoverInnerContent, PopoverWrapper }}
                    innerProps={{ popoverLinkProps: { tabIndex: '-1' }}} /> :
                  displayName
              }
            </Follow>
          </Size>
        )
      }
    </SizeList>
    {
      exceedsLimit &&
      <ToggleBtn
        toggleOnName="Show All"
        toggleOffName="Show Fewer"
        expanded={ expanded }
        toggleHandlers={ toggleHandlers } />
    }
  </Sizes>

SizeDetails.propTypes = {
  diameter: PropTypes.string,
  exceedsLimit: PropTypes.bool,
  expanded: PropTypes.bool,
  tireSizes: PropTypes.arrayOf(PropTypes.shape()),
  toggleHandlers: PropTypes.shape()
}

export default SizeDetails


const Diameter = styled.h4`
  ${Mixin.responsive('padding', '0 0 16px', '10px 0 16px')}
  ${Mixin.font.GothamBold(14)}
  margin: 0;
`

const Sizes = styled.div`
  ${Mixin.responsive('margin-bottom', '45px', '30px')}
`

const SizeList = styled.ul`
  padding: 0;
  margin: 0;
  list-style: none;
`

const Size = styled.li`
  & + & {
    margin-top: 10px;
  }
`

const propsToRemove = [
  'follow_alternative'
]

const LinkButton = Button.withComponent(props => <Link { ...filterProps(props, propsToRemove) } />)
const Follow = styled(LinkButton)`
  display: block;
  text-decoration: none;
  white-space: nowrap;
  ${Mixin.responsive('width', '300px', '288px')};

  :hover {
    text-decoration: none;
  }
`

const StyledPopover = styled(Popover)`
  font: inherit;
`
